{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://forms/rsu-award",
  "title": "RSU Award",
  "description": "RSU (Restricted Stock Unit) award — create and edit unified form.",
  "type": "object",
  "properties": {
    "participantId": {
      "$ref": "module://rsu-award#properties/participantId",
      "required": true,
      "permissions": { "edit": "EDIT_PARTICIPANT_FIELD" },
      "disabledDisplayField": "participantName"
    },
    "id": {
      "$ref": "module://rsu-award#properties/id"
    },
    "participantName": {
      "type": "string",
      "widget": "hidden"
    },
    "firstName": {
      "$ref": "module://rsu-award#properties/firstName",
      "readOnly": true
    },
    "middleName": {
      "$ref": "module://rsu-award#properties/middleName",
      "readOnly": true
    },
    "lastName": {
      "$ref": "module://rsu-award#properties/lastName",
      "readOnly": true
    },
    "awardNumber": {
      "$ref": "module://rsu-award#properties/awardNumber",
      "required": true
    },
    "isUnvestedAcquisition": {
      "$ref": "module://rsu-award#properties/isUnvestedAcquisition",
      "required": true
    },
    "grantId": {
      "$ref": "module://rsu-award#properties/grantId",
      "required": true
    },
    "planId": {
      "$ref": "module://rsu-award#properties/planId"
    },
    "planName": {
      "$ref": "module://rsu-award#properties/planName",
      "readOnly": true
    },
    "planTypeId": {
      "$ref": "module://rsu-award#properties/planTypeId"
    },
    "planType": {
      "$ref": "module://rsu-award#properties/planType",
      "readOnly": true
    },
    "grantName": {
      "$ref": "module://rsu-award#properties/grantName",
      "widget": "hidden"
    },
    "isOffline": {
      "$ref": "module://rsu-award#properties/isOffline"
    },
    "issuedUnits": {
      "$ref": "module://rsu-award#properties/issuedUnits",
      "required": true
    },
    "fmvAtGrant": {
      "$ref": "module://rsu-award#properties/fmvAtGrant",
      "required": true
    },
    "grantPrice": {
      "$ref": "module://rsu-award#properties/grantPrice",
      "readOnly": true
    },
    "grantValue": {
      "$ref": "module://rsu-award#properties/grantValue",
      "required": true
    },
    "grantIssueDate": {
      "$ref": "module://rsu-award#properties/grantIssueDate",
      "required": true
    },
    "vestingStartDate": {
      "$ref": "module://rsu-award#properties/vestingStartDate",
      "required": true
    },
    "vestingTemplateId": {
      "$ref": "module://rsu-award#properties/vestingTemplateId"
    },
    "vestingTemplateName": {
      "$ref": "module://rsu-award#properties/vestingTemplateName",
      "widget": "hidden"
    },
    "poolId": {
      "$ref": "module://rsu-award#properties/poolId"
    },
    "grantReason": {
      "$ref": "module://rsu-award#properties/grantReason",
      "required": true
    },
    "notes": {
      "$ref": "module://rsu-award#properties/notes"
    },
    "settlementConfiguration": {
      "$ref": "module://settlement#/$defs/settlementConfiguration",
      "hiddenWhen": {
        "meta": "env",
        "in": [
          "uat",
          "production"
        ]
      }
    },
    "settlementTypeId": {
      "$ref": "module://settlement#/$defs/settlementTypeId",
      "hiddenWhen": {
        "meta": "env",
        "in": [
          "development",
          "qa"
        ]
      }
    },
    "isAccepted": {
      "$ref": "module://rsu-award#properties/isAccepted",
      "hiddenWhen": {
        "field": "#/properties/isOffline",
        "notEquals": true
      }
    },
    "acceptanceDate": {
      "$ref": "module://rsu-award#properties/acceptanceDate",
      "hiddenWhen": {
        "anyOf": [
          {
            "field": "#/properties/isOffline",
            "notEquals": true
          },
          {
            "field": "#/properties/isAccepted",
            "notEquals": true
          }
        ]
      }
    },
    "awardAcceptanceDocumentInput": {
      "$ref": "module://rsu-award#properties/awardAcceptanceDocumentInput",
      "hiddenWhen": {
        "anyOf": [
          {
            "field": "#/properties/isOffline",
            "notEquals": true
          },
          {
            "field": "#/properties/isAccepted",
            "notEquals": true
          }
        ]
      }
    },
    "acceptanceDocumentId": {
      "$ref": "module://rsu-award#properties/acceptanceDocumentId"
    },
    "acceptanceDocumentRemovedIds": {
      "$ref": "module://rsu-award#properties/acceptanceDocumentRemovedIds"
    },
    "acceptanceDocumentName": {
      "$ref": "module://rsu-award#properties/acceptanceDocumentName",
      "readOnly": true
    },
    "acceptanceMethodId": {
      "$ref": "module://rsu-award#properties/acceptanceMethodId"
    },
    "acceptanceMethodName": {
      "$ref": "module://rsu-award#properties/acceptanceMethodName",
      "readOnly": true
    },
    "methodType": {
      "$ref": "module://rsu-award#properties/methodType"
    },
    "methodTypeId": {
      "$ref": "module://rsu-award#properties/methodTypeId"
    },
    "awardAdjustmentMethodId": {
      "$ref": "module://rsu-award#properties/awardAdjustmentMethodId"
    },
    "asOfDate": {
      "$ref": "module://rsu-award#properties/asOfDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "residualDate": {
      "$ref": "module://rsu-award#properties/residualDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "amortizationDate": {
      "$ref": "module://rsu-award#properties/amortizationDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "cancelShareTypeId": {
      "$ref": "module://rsu-award#properties/cancelShareTypeId",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "targetCancelled": {
      "$ref": "module://rsu-award#properties/targetCancelled",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "adjustmentReason": {
      "$ref": "module://rsu-award#properties/adjustmentReason",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_RSU_AWARD",
      "successMessage": "RSU Award saved successfully",
      "refreshEntities": [
        "RSU Award"
      ]
    }
  },
  "modes": {
    "create": {
      "type": "array",
      "items": {
        "$ref": "#"
      },
      "minItems": 1,
      "maxItems": 25,
      "dataSource": {
        "submit": {
          "actionId": "SAVE_RSU_AWARD",
          "successMessage": "RSU Award(s) created successfully",
          "refreshEntities": [
            "RSU Award"
          ],
          "constants": {
            "importType": "add"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "reset"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_RSU_AWARD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "actionId": "SAVE_RSU_AWARD",
          "successMessage": "RSU Award updated successfully",
          "refreshEntities": [
            "RSU Award"
          ],
          "constants": {
            "importType": "edit"
          },
          "invalidateActions": [
            "FETCH_RSU_AWARD"
          ]
        }
      },
      "lifecycle": {
        "dirtyGuard": true,
        "submitBehavior": "close",
        "serverErrors": "inline"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_RSU_AWARD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
